import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import ProviderCard from './ProviderCard';

const ProviderList = (props) => {
  const {
    hasSearched,
    onCardClick,
    onCardMouseEnter,
    onCardMouseLeave,
    providers,
    selectedProvider,
  } = props;

  const message = get(window, 'uuSearchSettings.no-results-message', '');

  if (hasSearched && isEmpty(providers)) {
    return (
      <div className="uu-no-results">
        <p>{isEmpty(message) ? 'Sorry, no providers were found.' : message}</p>
      </div>
    );
  }


  return (
    <div className="uu-provider-list">
      {
        providers.map(provider => (
          <ProviderCard
            key={provider.id}
            onCardClick={onCardClick}
            onCardMouseEnter={onCardMouseEnter}
            onCardMouseLeave={onCardMouseLeave}
            provider={provider}
            selectedProvider={selectedProvider}
          />
        ))
      }
    </div>
  );
};

ProviderList.propTypes = {
  hasSearched: PropTypes.bool.isRequired,
  onCardClick: PropTypes.func.isRequired,
  onCardMouseEnter: PropTypes.func.isRequired,
  onCardMouseLeave: PropTypes.func.isRequired,
  providers: PropTypes.array,
  selectedProvider: PropTypes.object.isRequired,
};

ProviderList.defaultProps = {
  providers: [],
};

export default ProviderList;



// WEBPACK FOOTER //
// ./public/js/components/ProviderList/index.jsx